export default (priceValue: number): string => {
  const text = `${(priceValue / 100).toFixed(2)}€`;
  return text.replace(".", ",");
};
